import request from '@/utils/request'
//客户案例详情
export const getCaseDetails = (id) => request.get(`/official/home/customerCase/${id}`)
